"use strict";
import {on, find, removeClass, findIn, findAllIn, removeAttribute, setAttribute} from "@elements/dom-utils";
import TerracePlanner from "../index";

let additionalInfoPanel;
export function init() {
    additionalInfoPanel = findIn('.js-planner__substructure-additional-info', TerracePlanner.element);

    if (findAllIn('.js-planner__construction-input', TerracePlanner.element)) {
        findAllIn('.js-planner__construction-input', TerracePlanner.element).map((input) => {
            if (input.getAttribute('data-target-fieldset')) {
                on('change', (evt) => setPanelListener(evt, input), input);
            }
        });
    }
}

/**
 * listener to toggle visibility on panels containing sets
 *
 * @param event
 */
function setPanelListener(evt, input) {
    findAllIn('.js-planner__fieldset', TerracePlanner.element).map((fieldset) => {
        setAttribute('hidden', true, fieldset);
    });

    let targetPanelId = input.getAttribute('data-target-fieldset');
    let targetPanel = find('.js-planner__fieldset[data-fieldset-id="'+ targetPanelId +'"]');

    closeAdditionalInfo();

    removeAttribute('hidden', targetPanel);
}

/**
 * listener to toggle open detail panels
 *
 * @param item
 */

/**
 * opens and scrolls to the additional info panel
 */
export function openAdditionalInfo() {
    if (additionalInfoPanel) {
        removeAttribute('hidden', additionalInfoPanel);

        let top = additionalInfoPanel.getBoundingClientRect().top - document.body.getBoundingClientRect().top - find('.js-nav-container').getBoundingClientRect().height - 20;

        try {
            window.scroll({
                top: top,
                behavior: 'smooth'
            });
        } catch (e) {
            window.scrollTo(0, top);
        }
    }
}

/**
 * closes the additional info panel
 */
function closeAdditionalInfo() {
    setAttribute('hidden', true, additionalInfoPanel);
    removeClass('is-open', additionalInfoPanel);
}